import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
    BoxContainer,
    BoxTitle,
    BoxHead,
    Underline,
    FilterTableWrapper,
    FilterWrapper,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import SideModal from "../../Components/SideModal";
import AddLocation from "../../Components/Location/AddLocation";
import Table from "../../Components/Location/Table";
import EditLocation from "../../Components/Location/EditLocation";
import { Save_Locations } from "../../Redux/actions";
import { useDispatch } from "react-redux";
import DeleteLocation from "../../Components/Location/DeleteLocation";

const Location = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.UserReducer.user);
    const [selectedData, setSelectedData] = useState("");
    const [apiData, setApiData] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const [showAddLocation, setShowAddLocation] = useState(false);
    const [isEditLocation, setIsEditLocation] = useState(false);
    const [isDeleteLocation, setIsDeleteLocation] = useState(false);

    const defaultLocations = {
        id: 0,
        name: "All Locations",
        clientId: 0,
    };
    const fetchFunction = async () => {
        const response = await axios.get(
            `${Config.apiUrl}/property/list/location`,
            {
                headers: {
                    authorization: "Bearer " + user.token,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.isSuccess) {
            setApiData(res.locations);
            setIsFocused(true);
        }
    };

    const getError = (err) => {
        toast.error(err?.response?.data?.msg || "An Error Occured");
    };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        isRefetching,
        data,
        refetch,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        getListMutate();
    }, [getListMutate]);

    //------- Add Location Model -------

    const addLocationFunction = async (payload) => {
        return await axios.post(`${Config.apiUrl}/property/add/location`, payload, {
            headers: {
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const { isLoading: addLocationLoading, mutate: addLocationMutate } = useMutation(
        addLocationFunction,
        {
            onSettled: () => {
                setShowAddLocation(false);
            },
            onSuccess: ({ data }) => {
                dispatch(Save_Locations([defaultLocations, ...data?.locations]));
                getListMutate();
                toast.success(data?.msg || 'Success');
            },
            onError: (error) => {
                toast.error(error?.response?.data?.msg || 'An error occurred');
            },
        }
    );

    //------- Edit Location Model -------

    const editLocationFunction = async (payload) => {
        return await axios.post(`${Config.apiUrl}/property/edit/location`, payload, {
            headers: {
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const { isLoading: editLocationLoading, mutate: editLocationMutate } = useMutation(
        editLocationFunction,
        {
            onSettled: () => {
                setIsEditLocation(false);
            },
            onSuccess: ({ data }) => {
                //dispatch(Save_Locations([defaultLocations, ...data?.locations]));
                getListMutate();
                toast.success(data?.msg || 'Success');
            },
            onError: (error) => {
                toast.error(error?.response?.data?.msg || 'An error occurred');
            },
        }
    );
    const handleEditClose = () => {
        setIsEditLocation(false);
    };
    const handleClose = () => {
        setShowAddLocation(false);
    };
    //------- Delete Location -------
    const deleteLocationFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/property/delete/location`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const deleteLoctationSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            setIsDeleteLocation(false);
            getListMutate();
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const deleteLocationError = (data) => {
        setIsDeleteLocation(false);
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: deleteLocationLoading, mutate: deleteLocationMutate } =
        useMutation(deleteLocationFunction, {
            onSuccess: deleteLoctationSuccess,
            onError: deleteLocationError,
        });
    const handleLocationClose = () => {
        setIsDeleteLocation(false);
    };
    return (
        <BoxContainer>
            <BoxHead>
                <BoxTitle className="!mb-0 whitespace-nowrap">
                    Location
                    <Underline />
                </BoxTitle>
                <div className="flex space-x-4 md:ml-auto">
                    <AddBtn
                        type="button"
                        onClick={() => {
                            setShowAddLocation(true);
                        }}
                    >
                        {"Add Location"}
                    </AddBtn>
                </div>
            </BoxHead>
            <SideModal
                isOpen={showAddLocation}
                onClose={() => setShowAddLocation(false)}
            >
                <AddLocation
                    setShowAddLocation={setShowAddLocation}
                    showAddLocation={showAddLocation}
                    addLocationLoading={addLocationLoading}
                    addLocationMutate={addLocationMutate}
                    handleClose={handleClose}
                />
            </SideModal>
            <SideModal
                isOpen={isEditLocation}
                onClose={() => setIsEditLocation(false)}
            >
                <EditLocation
                    setIsEditLocation={setIsEditLocation}
                    isEditLocation={isEditLocation}
                    editLocationLoading={editLocationLoading}
                    editLocationMutate={editLocationMutate}
                    handleEditClose={handleEditClose}
                    selectedData={selectedData}
                />
            </SideModal>
            {isDeleteLocation && (
                <DeleteLocation
                    setIsDeleteLocation={setIsDeleteLocation}
                    isDeleteLocation={isDeleteLocation}
                    deleteLocationLoading={deleteLocationLoading}
                    deleteLocationMutate={deleteLocationMutate}
                    selectedData={selectedData}
                    handleClose={handleLocationClose}
                />
            )}
            <FilterTableWrapper>
                <FilterWrapper>
                    <div className="flex items-center">
                        <Text>
                            Total records:{" "}
                            <span className="font-semibold">
                                {apiData?.length || 0}
                            </span>
                        </Text>
                    </div>
                </FilterWrapper>
                {!error && !isLoading && data && (
                    <TableWrapper>
                        <Table
                            apiData={apiData || []}
                            setSelectedData={setSelectedData}
                            selectedData={selectedData}
                            setIsEditLocation={setIsEditLocation}
                            setIsDeleteLocation={setIsDeleteLocation}
                        />
                        {(!apiData || apiData.length === 0) && <NotFoundModel />}
                    </TableWrapper>
                )}
            </FilterTableWrapper>

            {error && !isLoading && <NotFoundModel />}
            {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
    );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md`;
const AddBtn = tw.button`whitespace-nowrap flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6 cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm`;

const Text = tw.p`text-gray-500 text-sm font-normal`;

export default Location;
